<template>
  <VueperSlides
    autoplay
    class="no-shadow"
    :visible-slides="3"
    :breakpoints="breakpoints"
    :touchable="false"
    fixed-height="350px"
    duration="10000"
    :dragging-distance="20"
  >
    <VueperSlide
      v-for="(slide, index) in slides"
      :key="'locker_how_'+index"
    >
      <template #content>
        <div class="box_how mr-3 ml-3">
          <img
            class="align-middle img-fluid mb-4"
            :src="slide.img"
            :alt="slide.title"
            :title="slide.title"
            height="200"
            width="200"
            style="height: 200px; max-width: 70%; width: auto;"
          >
          <h4>{{ slide.title }}</h4>
          <p>{{ slide.text }}</p>
        </div>
      </template>
    </VueperSlide>
  </VueperSlides>
</template>

<script>
import { VueperSlide, VueperSlides } from 'vueperslides';
import step1Img from '../../assets/img/illustrations/lockers/locker_1.png';
import step2Img from '../../assets/img/illustrations/lockers/locker_2.png';
import step3Img from '../../assets/img/illustrations/lockers/locker_3.png';

export default {
  name: 'LockerHowWorksCarousel',
  components: {
    VueperSlides,
    VueperSlide,
  },

  data() {
    return {
      breakpoints: {
        992: {
          visibleSlides: 1,
          slideMultiple: 1,
          arrows: true,
          bulletsOutside: true,
          touchable: true,
          fixedHeight: '350px',
        },
      },
    };
  },

  computed: {
    slides() {
      return [
        {
          img: step1Img,
          title: this.$t('lang.locker_home.how_works.step1_title'),
          text: this.$t('lang.locker_home.how_works.step1'),
        },
        {
          img: step2Img,
          title: this.$t('lang.locker_home.how_works.step2_title'),
          text: this.$t('lang.locker_home.how_works.step2'),
        },
        {
          img: step3Img,
          title: this.$t('lang.locker_home.how_works.step3_title'),
          text: this.$t('lang.locker_home.how_works.step3'),
        },
      ];
    },
  },
};
</script>
